import { style } from "styled-system"

export const layer = style({
  // React prop name and CSS property
  prop: "layer",
  // CSS property (if different from prop argument)
  cssProperty: "zIndex",
  // key for theme values
  key: "layers",
  // accessor function for transforming the value
  transformValue: (n, scale) =>
    // @ts-ignore
    scale[n]
})
